import React, { memo } from 'react'
import { Path, Circle as _Circle, Rect } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M8.00003 1.25C6.84381 1.24975 5.7069 1.54651 4.6983 2.11183C3.6897 2.67715 2.84322 3.49207 2.24 4.47848C1.63679 5.46489 1.29707 6.5897 1.25341 7.74511C1.20975 8.90051 1.46361 10.0478 1.99066 11.0769L1.31253 13.1038C1.23817 13.3244 1.22691 13.5614 1.28004 13.7881C1.33316 14.0148 1.44854 14.2222 1.61319 14.3868C1.77783 14.5515 1.98519 14.6669 2.2119 14.72C2.4386 14.7731 2.67563 14.7619 2.89628 14.6875L4.92316 14.0119C5.83193 14.4758 6.83405 14.7277 7.85419 14.7486C8.87432 14.7695 9.88592 14.5588 10.8129 14.1324C11.7399 13.7061 12.5582 13.0751 13.2062 12.287C13.8542 11.4988 14.3152 10.574 14.5543 9.58208C14.7935 8.59016 14.8046 7.55692 14.587 6.56006C14.3693 5.5632 13.9285 4.62866 13.2976 3.8267C12.6668 3.02473 11.8623 2.37623 10.9448 1.92993C10.0272 1.48363 9.02038 1.25116 8.00003 1.25ZM8.00003 13.25C7.0771 13.2504 6.17039 13.0074 5.37128 12.5456C5.25734 12.4795 5.12801 12.4446 4.99628 12.4444C4.91556 12.4445 4.83537 12.4576 4.75878 12.4831L2.89691 13.1038L3.51753 11.2419C3.55114 11.1411 3.56295 11.0343 3.55217 10.9286C3.5414 10.8229 3.50829 10.7207 3.45503 10.6288C2.87627 9.62822 2.64388 8.46465 2.79391 7.31856C2.94394 6.17247 3.468 5.10793 4.2848 4.29008C5.10159 3.47223 6.16546 2.9468 7.31135 2.7953C8.45725 2.64379 9.62111 2.87468 10.6224 3.45215C11.6237 4.02962 12.4064 4.92139 12.8491 5.9891C13.2918 7.05682 13.3698 8.2408 13.071 9.35737C12.7721 10.4739 12.1132 11.4607 11.1963 12.1645C10.2794 12.8683 9.1559 13.2499 8.00003 13.25Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconChatCircle'

export const IconChatCircle = memo(themed(Icon))
